gsap.registerPlugin(ScrollTrigger);

gsap.from('#Banner-template--19396475846792_image_banner_XXKrKp .banner__box', {
  y: 100,
  duration: 1.2,
  opacity: 0
});

gsap.from('#Banner-template--19396475846792_image_banner_CGh8Q4 .banner__box', {
  y: 100,
  duration: 1,
  opacity: 0,
  scrollTrigger: {
    trigger: '#shopify-section-template--19396475846792_image_banner_CGh8Q4',
    start: 'top 90%',
    end: 'bottom top',
    scrub: 1
  }
});

gsap.from('#shopify-section-template--19396475846792__carousel_images_GB8k3g .slider-cards__title', {
  y: 50,
  duration: 1,
  opacity: 0,
  scrollTrigger: {
    trigger: '#shopify-section-template--19396475846792__carousel_images_GB8k3g',
    start: 'top 90%',
    end: 'bottom 90%',
    scrub: 1
  }
});

gsap.from("#Slider-template--19396475846792__carousel_images_GB8k3g .grid__item", {
  y: 50,
  opacity: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: "#shopify-section-template--19396475846792__carousel_images_GB8k3g",
    start: "top 100%",
		end: '+=500',
    scrub: 1
  }
});

gsap.from("#shopify-section-template--19396475846792__slideshow_JmWCRj", {
  opacity: 0,
  ease: "none",
  scrollTrigger: {
    trigger: "#shopify-section-template--19396475846792__slideshow_JmWCRj",
    start: "top 85%",
    end: "top 60%",
    scrub: 1
  }
});